import { render, staticRenderFns } from "./JoinSoccerTeamWrapper.vue?vue&type=template&id=0f90edf5&scoped=true&"
import script from "./JoinSoccerTeamWrapper.vue?vue&type=script&lang=js&"
export * from "./JoinSoccerTeamWrapper.vue?vue&type=script&lang=js&"
import style0 from "./JoinSoccerTeamWrapper.vue?vue&type=style&index=0&id=0f90edf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90edf5",
  null
  
)

export default component.exports